import {exhibitionMapConstants} from "../constants/exhibition-map.constants";
import {exhibitionMapService} from "../services/exhibition-map.service";
import {modalActions} from "./modal.actions";

const getRooms = () => {
    return dispatch => {
        exhibitionMapService.getList()
            .then(
                rooms => {
                    dispatch({type: exhibitionMapConstants.ROOMS_LIST_SUCCESS, rooms})
                },
                error => {
                    dispatch({type: exhibitionMapConstants.ROOMS_LIST_FAILURE, error})
                }
            )
    }
};

const createHotspot = (hotspotModel) => {
    return dispatch => {
        exhibitionMapService.addHotspot(hotspotModel)
            .then(
                hotspot => {
                    dispatch(getRooms());
                    dispatch(modalActions.hideModal());
                },
                error => {
                    dispatch({type: exhibitionMapConstants.ROOMS_LIST_FAILURE, error })
                }
            )
    }
};

const editHotspot = (hotspotModel) => {
    return dispatch => {
        exhibitionMapService.editHotspot(hotspotModel)
            .then(
                hotspotModel => {
                    dispatch(getRooms());
                    dispatch(modalActions.hideModal());
                },
                error => {
                    dispatch({type: exhibitionMapConstants.ROOMS_LIST_FAILURE, error})
                }
            )
    }
};

const deleteHotspot = (id) => {
    return dispatch => {
        exhibitionMapService.deleteHotspot(id)
            .then(
                () => {
                    dispatch(getRooms());
                    dispatch(modalActions.hideModal())
                },
                error => {
                    dispatch({type: exhibitionMapConstants.ROOMS_LIST_FAILURE, error})
                }
            )
    }
};

const createMapConfig = (mapConfigModel) => {
    return dispatch => {
        exhibitionMapService.addMapConfig(mapConfigModel)
            .then(
                () => {
                    dispatch(getRooms());
                    dispatch(modalActions.hideModal())
                },
                error => {
                    dispatch({type: exhibitionMapConstants.MAP_CONFIG_CRUD_FAILURE, error})
                }
            );
    }
};

const editMapConfig = (mapConfigModel) => {
    return dispatch => {
        exhibitionMapService.editMapConfig(mapConfigModel)
            .then(
                () => {
                    dispatch(getRooms());
                    dispatch(modalActions.hideModal())
                },
                error => {
                    dispatch({type: exhibitionMapConstants.MAP_CONFIG_CRUD_FAILURE, error})
                }
            );
    }
};

const deleteMapConfig = (id) => {
    return dispatch => {
        exhibitionMapService.deleteMapConfig(id)
            .then(
                () => {
                    dispatch(getRooms());
                    dispatch(modalActions.hideModal())
                },
                error => {
                    dispatch({type: exhibitionMapConstants.MAP_CONFIG_CRUD_FAILURE, error})
                }
            );
    }
};

const clearList = () => {
    return dispatch => {
        dispatch({type: exhibitionMapConstants.ROOMS_LIST_CLEAR})
    }
};


export const exhibitionMapActions = {
    getRooms,
    // hotspot actions
    createHotspot,
    editHotspot,
    deleteHotspot,
    //maps actions
    createMapConfig,
    editMapConfig,
    deleteMapConfig,
    clearList
};
